import { useRouter } from 'next/router';

import { makeStyles } from '@material-ui/core/styles';

import PropTypes from 'prop-types';

import { Section, SectionAlternate } from '@/src/components/organisms';
import { useStickySWR } from '@/src/lib/hooks';
import { nextAPIfetcher } from '@/src/lib/utils';

import { Hero, Results } from './components';

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%',
    width: '100%',
  },
  pagePaddingTop: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    [theme.breakpoints.up('md')]: {
      paddingTop: theme.spacing(5),
      paddingBottom: theme.spacing(3),
    },
  },
  sectionPadding: {
    padding: 0,
  },
}));

export default function BlogIndex({ doc }) {
  const router = useRouter();
  const classes = useStyles();

  const { page = 1, search = '' } = router.query;
  const { posts, categories } = doc;

  const { data, isValidating } = useStickySWR(
    page ? `/blog/posts?page=${page}&search=${search}` : null,
    nextAPIfetcher,
    { initialData: page === 1 ? posts : undefined },
  );

  return (
    <div className={classes.root}>
      <Section className={classes.pagePaddingTop}>
        <Hero categories={categories} loading={!data || isValidating} />
      </Section>
      <SectionAlternate>
        <Results data={data} />
      </SectionAlternate>
    </div>
  );
}

BlogIndex.propTypes = {
  doc: PropTypes.object,
};
